import { type Path } from 'react-hook-form';

import { type BlockedUserCreationFormType } from './schema';

type PathOfBlockedUserCreationFormType = Path<BlockedUserCreationFormType>;

export const BLOCKED_USER_CREATION_FIELDS_NAME = {
  personal: {
    idType: 'personal.idType',
    idNumber: 'personal.idNumber',
    title: 'personal.title',
    firstName: 'personal.firstName',
    middleName: 'personal.middleName',
    lastName: 'personal.lastName',
    email: 'personal.email',
    phoneNumber: 'personal.phoneNumber',
  },
  blocklistInfo: {
    blockedType: 'blocklistInfo.blockedType',
    examCenter: 'blocklistInfo.examCenter',
    position: 'blocklistInfo.position',
    department: 'blocklistInfo.department',
    blockedAt: 'blocklistInfo.blockedAt',
    enforcementEndAssign: 'blocklistInfo.enforcementEnd.assign',
    enforcementEndDuration: 'blocklistInfo.enforcementEnd.duration',
    enforcementEndDate: 'blocklistInfo.enforcementEnd.date',
    blockedCourseType: 'blocklistInfo.blockedCourses.type',
    blockedCourseCourses: 'blocklistInfo.blockedCourses.courses',
    reason: 'blocklistInfo.reason',
    fileDocuments: 'blocklistInfo.fileAttachments',
    examRound: 'blocklistInfo.examSessionInfo.round',
    examStartTime: 'blocklistInfo.examSessionInfo.startedAt',
    examEndTime: 'blocklistInfo.examSessionInfo.endedAt',
    examDate: 'blocklistInfo.examSessionInfo.examDate',
  },
} as const satisfies {
  personal: Record<string, PathOfBlockedUserCreationFormType>;
  blocklistInfo: Record<string, PathOfBlockedUserCreationFormType>;
  blockedSchemaType?: PathOfBlockedUserCreationFormType;
};
